/**
 * ERA App Management API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { CreateDiagnosticRequestDto } from '../model/createDiagnosticRequestDto';
// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { LatestDeviceDiagnosticDto } from '../model/latestDeviceDiagnosticDto';
// @ts-ignore
import { ProblemDetails } from '../model/problemDetails';
// @ts-ignore
import { RequestDiagnosticRequest } from '../model/requestDiagnosticRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';


export interface CreateDiagnosticRequestParams {
    /** Model containing the diagnostic\&#39;s information. */
    createDiagnosticRequestDto: CreateDiagnosticRequestDto;
}

export interface QueryLatestDeviceDiagnosticsRequestParams {
    /** The device UDIDs to query. */
    requestBody: Array<string>;
}

export interface RequestDiagnosticRequestParams {
    /** Use a list of filters to narrow down which notification subscribers should receive this diagnostic request.  Refer to the Schema for detailed explanations of the individual filter types.  Select everything directly or indirectly assigned to a location. This excludes anything assigned to only brands. Use this for: - broadly selecting a lot of devices. &#x60;&#x60;&#x60; {   \&quot;type\&quot;: \&quot;heartbeat\&quot;,   \&quot;filters\&quot;: [     {\&quot;type\&quot;: \&quot;category-type\&quot;, \&quot;value\&quot;: \&quot;location\&quot;}   ] } &#x60;&#x60;&#x60; Select everything directly or indirectly assigned to a room, while also being a direct or indirect child of a category with the id &#x60;0f415bc1-0dcc-4f05-a75c-f51463156187&#x60;. Use this for: - selecting devices nested in a specific category - selecting devices of a specific type or subtype nested in a specific category - selecting devices in a specific room - selecting devices in a room on a specific location &#x60;&#x60;&#x60; {   \&quot;type\&quot;: \&quot;heartbeat\&quot;,   \&quot;filters\&quot;: [     {\&quot;type\&quot;: \&quot;category-type\&quot;, \&quot;value\&quot;: \&quot;room\&quot;},     {\&quot;type\&quot;: \&quot;category\&quot;, \&quot;value\&quot;: \&quot;0f415bc1-0dcc-4f05-a75c-f51463156187\&quot;}   ] } &#x60;&#x60;&#x60; Select everything directly assigned to any kiosk. Use this for: - selecting devices assigned directly to a specific category type - selecting all kiosk devices in the whole account &#x60;&#x60;&#x60; {   \&quot;type\&quot;: \&quot;heartbeat\&quot;,   \&quot;filters\&quot;: [     {\&quot;type\&quot;: \&quot;main-category\&quot;, \&quot;value\&quot;: \&quot;kiosk\&quot;},   ] } &#x60;&#x60;&#x60; Select everything directly assigned to any kiosk, while also being a direct or indirect child of a category with the id &#x60;0f415bc1-0dcc-4f05-a75c-f51463156187&#x60;. Use this for: - selecting devices assigned directly to a specific category type inside another category - selecting all kiosk devices in a specific location &#x60;&#x60;&#x60; {   \&quot;type\&quot;: \&quot;heartbeat\&quot;,   \&quot;filters\&quot;: [     {\&quot;type\&quot;: \&quot;main-category\&quot;, \&quot;value\&quot;: \&quot;kiosk\&quot;},     {\&quot;type\&quot;: \&quot;category\&quot;, \&quot;value\&quot;: \&quot;0f415bc1-0dcc-4f05-a75c-f51463156187\&quot;}   ] } &#x60;&#x60;&#x60; Select a specific device, all applications on that device. &#x60;&#x60;&#x60; {   \&quot;type\&quot;: \&quot;heartbeat\&quot;,   \&quot;filters\&quot;: [     {\&quot;type\&quot;: \&quot;apple-device-udid\&quot;, \&quot;value\&quot;: \&quot;00007220-000263FD0A22209A\&quot;}   ] } &#x60;&#x60;&#x60; Select a specific application, across all devices. &#x60;&#x60;&#x60; {   \&quot;type\&quot;: \&quot;heartbeat\&quot;,   \&quot;filters\&quot;: [     {\&quot;type\&quot;: \&quot;apple-bundle-id\&quot;, \&quot;value\&quot;: \&quot;com.citizenm.kiosk\&quot;}   ] } &#x60;&#x60;&#x60; Select all devices with the mamba app nested inside the category with id &#x60;0f415bc1-0dcc-4f05-a75c-f51463156187&#x60;.         Use this for: - selecting devices with a specific app in a specific hotel &#x60;&#x60;&#x60; {   \&quot;type\&quot;: \&quot;heartbeat\&quot;,   \&quot;filters\&quot;: [     {\&quot;type\&quot;: \&quot;apple-bundle-id\&quot;, \&quot;value\&quot;: \&quot;com.citizenm.mamba\&quot;},     {\&quot;type\&quot;: \&quot;category\&quot;, \&quot;value\&quot;: \&quot;0f415bc1-0dcc-4f05-a75c-f51463156187\&quot;}   ] } &#x60;&#x60;&#x60; */
    requestDiagnosticRequest: RequestDiagnosticRequest;
}


@Injectable({
  providedIn: 'root'
})
export class DiagnosticsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Create a diagnostic for an application installed on a device.
     * @endpoint post /diagnostics
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createDiagnostic(requestParameters: CreateDiagnosticRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public createDiagnostic(requestParameters: CreateDiagnosticRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public createDiagnostic(requestParameters: CreateDiagnosticRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public createDiagnostic(requestParameters: CreateDiagnosticRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const createDiagnosticRequestDto = requestParameters?.createDiagnosticRequestDto;
        if (createDiagnosticRequestDto === null || createDiagnosticRequestDto === undefined) {
            throw new Error('Required parameter createDiagnosticRequestDto was null or undefined when calling createDiagnostic.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/diagnostics`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: createDiagnosticRequestDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the latest diagnostic for each requested device.
     * @endpoint post /diagnostics/latest/query
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public queryLatestDeviceDiagnostics(requestParameters: QueryLatestDeviceDiagnosticsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<LatestDeviceDiagnosticDto>>;
    public queryLatestDeviceDiagnostics(requestParameters: QueryLatestDeviceDiagnosticsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<LatestDeviceDiagnosticDto>>>;
    public queryLatestDeviceDiagnostics(requestParameters: QueryLatestDeviceDiagnosticsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<LatestDeviceDiagnosticDto>>>;
    public queryLatestDeviceDiagnostics(requestParameters: QueryLatestDeviceDiagnosticsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const requestBody = requestParameters?.requestBody;
        if (requestBody === null || requestBody === undefined) {
            throw new Error('Required parameter requestBody was null or undefined when calling queryLatestDeviceDiagnostics.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/diagnostics/latest/query`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<LatestDeviceDiagnosticDto>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: requestBody,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Request a diagnostic from applications using a filter.
     * @endpoint post /diagnostics/request
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public requestDiagnostic(requestParameters: RequestDiagnosticRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public requestDiagnostic(requestParameters: RequestDiagnosticRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public requestDiagnostic(requestParameters: RequestDiagnosticRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public requestDiagnostic(requestParameters: RequestDiagnosticRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const requestDiagnosticRequest = requestParameters?.requestDiagnosticRequest;
        if (requestDiagnosticRequest === null || requestDiagnosticRequest === undefined) {
            throw new Error('Required parameter requestDiagnosticRequest was null or undefined when calling requestDiagnostic.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/diagnostics/request`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: requestDiagnosticRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
